// extracted by mini-css-extract-plugin
module.exports = {"container":"e_uj","imageContainer":"e_vj","image":"e_wj","imageInverted":"e_xj","postedInfo":"e_yj","socials":"e_zj","date":"e_Aj"};